function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-s1-1{fill:#123856;}.cls-s1-2{fill:#2e536b;}.cls-s1-3{fill:#f4c156;}.cls-s1-4{fill:#c09233;}.cls-s1-5{fill:#eb3825;}.cls-s1-6{fill:#cb2b27;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "s1",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "s1-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-s1-1",
  x: 391.26,
  y: 345.8,
  width: 104.17,
  height: 31.44
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M374.21,358.19c-2.56,10-15.69,15.81-29.37,13s-22.74-13.2-20.2-23.21,15.7-15.81,29.38-13S376.76,348.19,374.21,358.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M230.83,165.72C222.28,202.8,178,224.35,132,213.86S55.51,164.79,64.05,127.7s52.81-58.63,98.87-48.13S239.36,128.64,230.83,165.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M168.21,142c-8.55,37.08-52.81,58.63-98.86,48.13S-7.11,141.08,1.44,104s52.8-58.63,98.86-48.13S176.75,104.92,168.21,142Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M320.83,220.28c-8.55,37.09-52.8,58.63-98.86,48.15s-76.45-49.08-67.89-86.16,52.8-58.64,98.84-48.13S329.39,183.21,320.83,220.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M340,345.37c-5.31,20.94-32.49,33.21-60.7,27.38s-46.79-27.52-41.49-48.47,32.53-33.22,60.73-27.4S345.33,324.4,340,345.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M304.25,314.15c-9.69,40.76-60,64.46-112.25,52.91s-86.83-53.95-77.13-94.7,60-64.48,112.27-52.93S314,273.38,304.25,314.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M186.69,246.3c-8.8,37.16-54.41,58.75-101.84,48.23S6.11,245.35,14.91,208.19s54.4-58.79,101.85-48.26S195.49,209.11,186.69,246.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-2",
  d: "M251.28,84.13c-8.44,35.13-52.26,55.56-97.82,45.61S77.8,83.25,86.24,48.13,138.5-7.43,184.1,2.52,259.76,49,251.28,84.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-3",
  d: "M597.57,476.76c.39,0,.78,0,1.18,0a18.6,18.6,0,0,0,18.66-17.4,93.67,93.67,0,0,1,3.07-19.6,79.94,79.94,0,0,1,13.32-27.35c8.65-11.52,20.74-21.34,36.36-29.59a18.22,18.22,0,0,0,7.55-25,19.1,19.1,0,0,0-25.56-7.51c-29.75,15.72-50.47,36.57-61.95,62.25a119.7,119.7,0,0,0-8.41,27.34,139.9,139.9,0,0,0-2,17.33A18.69,18.69,0,0,0,597.57,476.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-3",
  d: "M962.24,381.86c15.73,8.14,28,17.87,36.81,29.34a80.68,80.68,0,0,1,13.75,27.26,95.09,95.09,0,0,1,3.38,19.58,18.79,18.79,0,0,0,18.93,17.26c.39,0,.79,0,1.18,0a18.5,18.5,0,0,0,17.5-19.62,137.22,137.22,0,0,0-2.31-17.31,120,120,0,0,0-8.83-27.28c-11.88-25.61-32.92-46.31-62.92-61.82a19,19,0,0,0-25.44,7.68A18.33,18.33,0,0,0,962.24,381.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-4",
  d: "M954.29,356.91a18.33,18.33,0,0,0,8,24.95c15.73,8.14,28,17.87,36.81,29.34l43.6-.15c-11.88-25.61-32.92-46.31-62.92-61.82A19,19,0,0,0,954.29,356.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-4",
  d: "M590.2,412.6l43.6-.15c8.65-11.52,20.74-21.34,36.36-29.59a18.22,18.22,0,0,0,7.55-25,19.1,19.1,0,0,0-25.56-7.51C622.4,366.07,601.68,386.92,590.2,412.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-5",
  d: "M387,26.54l51.07,169.91,42.82,142.44c8.77,29.16,36.18,49.18,67.18,49.07l503.57-1.73c31-.1,58.1-20.31,66.4-49.53L1129.59,296,1179.66,120l-61.87.21c-38.19.13-71.68,24.76-82.42,60.61-29.15,71.9-281.53,89-348.14,1.19,0,0,85.2-100.21-36.42-143.15S387,26.54,387,26.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-6",
  d: "M438.05,196.45l42.82,142.44c8.77,29.16,36.18,49.18,67.18,49.07l503.57-1.73c31-.1,58.1-20.31,66.4-49.53L1129.59,296c-17.36,26.42-50.66,62-113.49,65.18C858.15,369.28,525.22,356.49,438.05,196.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-3",
  d: "M378,39.55h0a10.75,10.75,0,0,0,12.35,7.37c28.37-5.4,78.82-12.22,109.19-12.33C554.2,34.41,603,41.74,644.41,56.37c28.92,10.22,46.13,24.36,51.13,42,7.69,27.21-14,60.95-23,71.62h0a18.34,18.34,0,0,0-.6,23h0c32.1,42.28,103.93,67.34,192.16,67h0c79.56-.28,168.83-22.76,188.94-72.36l.32-.81.24-.82A65.31,65.31,0,0,1,1077.76,152a67.78,67.78,0,0,1,40.17-13.18l61.75-.22a9.44,9.44,0,0,0,9.1-6.78h0a9.41,9.41,0,0,0-9.25-11.87l-61.75.22c-38.19.13-71.68,24.75-82.41,60.6-29.14,71.9-281.52,89-348.15,1.2,0,0,85.67-101.51-36.41-143.16C542.24,1.8,423,19.4,386.15,26.32A10.43,10.43,0,0,0,378,39.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s1-3",
  d: "M1178.33,493.06l-792.54,5.7a16.18,16.18,0,0,1-16.38-15.87,16,16,0,0,1,16.14-16l792.53-5.7c14.39,0,25.91-3.9,33.32-11.14a32,32,0,0,0,9.36-23.48c-.15-19.54-15.06-39.26-43.26-39.16a16.19,16.19,0,0,1-16.39-15.88,16,16,0,0,1,16.14-16c49-.17,75.77,36.41,76,70.9a63.16,63.16,0,0,1-18.87,46.2C1225,481.92,1207.54,493,1178.33,493.06Z"
})));

var SvgS1 = function SvgS1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1253.29 498.76",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgS1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/s1.879f741c.svg";
export { ForwardRef as ReactComponent };